// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React from 'react';
// eslint-disable-next-line node/no-missing-import
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
// eslint-disable-next-line node/no-missing-import
import Dropdown from '@salesforce/design-system-react/components/menu-dropdown';
// eslint-disable-next-line node/no-missing-import
import DropdownTrigger from '@salesforce/design-system-react/components/menu-dropdown/button-trigger';
// eslint-disable-next-line node/no-missing-import
import Button from '@salesforce/design-system-react/components/button/';
import PropTypes from 'prop-types';

function LanguageDropdown ({ ...props }) {
	const supportedLanguages = [
		{ label: 'English', value: 'en' },
		{ label: 'Deutsch', value: 'de' },
		{ label: 'Française (France)', value: 'fr' },
		{ label: 'Française (Canada)', value: 'fr-ca' },
		{ label: 'Português (Brasil)', value: 'pt' },
		{ label: 'Español (México)', value: 'es-xl' },
		{ label: 'Español (España)', value: 'es' },
		{ label: 'Italiano', value: 'it' },
		{ label: '日本語', value: 'ja' }
	];

	return (
		<div>
			<IconSettings iconPath="/assets/icons">
				<Dropdown
					tabIndex="0"
					align="right"
					options={supportedLanguages}
					onSelect={(selectedMenuItem) => {
						props.setLanguageInStore(selectedMenuItem.value);
						props.markLangChanged(true);
					}}
					iconSize="large"
					id="langDropdown"
				>
					<DropdownTrigger>
						<Button
							iconCategory="utility"
							iconName="down"
							iconPosition="right"
							label="Languages"
						/>
					</DropdownTrigger>
				</Dropdown>
			</IconSettings>
		</div>
	);
}

LanguageDropdown.propTypes = {
	setLanguageInStore: PropTypes.func.isRequired,
	markLangChanged: PropTypes.func.isRequired
};

export default LanguageDropdown;
